export default "__VITE_ASSET__Bzv0k4ZO__"